import { makeStyles } from "@mui/styles";
import dayjs from "dayjs";

import { styled } from "@mui/styles";
import React from "react";

import {
  Typography,
  Avatar,
  TableRow,
  TableCell,
  useMediaQuery,
} from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";

const useStyles = makeStyles((theme) => ({}));

const RowStyled = styled(TableRow)(({ theme }) => ({
  width: "100%",
  height: "120px",
  cursor: "pointer",
  transition:
    "transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  "&:hover": {
    boxShadow: "0 0 10px 0 rgba(73, 73, 73, 0.8)",
  },
  [theme.breakpoints.down("lg")]: {
    height: "fit-content",
    flexDirection: "column",
    padding: "15px 0",
  },
  [theme.breakpoints.down("md")]: {
    borderBottom: `1px solid #c4c9cc`,
  },
}));
const AvatarStyled = styled(Avatar)(({ theme }) => ({
  width: "40px",
  height: "40px",
}));

const TextNormal = styled(Typography)(({ theme, color }) => ({
  fontSize: "16px",
  color: theme.palette.text[color] || theme.palette.text["primary"],
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));

const TextSmall = styled(Typography)(({ theme, color }) => ({
  fontSize: "14px",
  color: theme.palette.text[color] || theme.palette.text["third"],
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

const StatusText = styled(Typography)(({ theme, status, typeOfBooking }) => ({
  fontSize: "15px",
  textAlign: "left",
  color:
    typeOfBooking === "DeliverySampleShuttleCar"
      ? status === "ได้รับสินค้าเรียบร้อย"
        ? "#4CAF50" // Green
        : status === "ส่งสินค้าเรียบร้อย"
        ? "#2196F3" // Blue
        : status === "รับสินค้าเรียบร้อย"
        ? "#FF9800" // Orange
        : status === "รอรับสินค้า"
        ? "#F44336" // Red
        : "inherit"
      : typeOfBooking === "BetweenSiteCar"
      ? status === "รายการเสร็จสิ้น"
        ? "#4CAF50" // Green
        : status === "กำลังดำเนินการ"
        ? "#FF9800" // Orange
        : status === "รอการจัดหาคนขับรถ"
        ? "#F44336" // Red
        : "inherit"[theme?.breakpoints?.down("sm")]
      : {
          fontSize: "14px",
        },
}));

const SiteInfo = ({ iconColor, siteName }) => (
  <div
    style={{ display: "flex", alignItems: "flex-start", marginBottom: "5px" }}
  >
    <LocationOnIcon
      sx={{
        height: "20px",
        color: iconColor,
        verticalAlign: "middle",
        marginRight: "4px",
      }}
    />
    <TextSmall color="primary">{siteName}</TextSmall>
  </div>
);

const Body = ({ bookingText, typeOfBooking, onClickCardHandler }) => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return isMobile ? (
    <RowStyled
      sx={{
        "& .MuiTableCell-root": {
          width: "100%",
        },
      }}
      onClick={() => onClickCardHandler(typeOfBooking, bookingText.bookingId)}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "12px",
        }}
      >
        <AvatarStyled
          src={`${process.env.REACT_APP_URL}image/profile/1.jpg`}
          alt="Profile"
          style={{ width: "50px", height: "50px", marginBlock: "12px" }}
        />
        <div
          style={{
            paddingLeft: "12px",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              <TextNormal>
                <strong> {bookingText.nameLabel} </strong>
                {bookingText.name}
              </TextNormal>
              {bookingText.email && (
                <TextNormal>
                  <strong>อีเมล </strong>
                  {bookingText.email}
                </TextNormal>
              )}
              <TextNormal>
                <strong>เบอร์โทรศัพท์ </strong>
                {bookingText.phone}
              </TextNormal>
              {bookingText.sampleName && (
                <TextNormal>
                  <strong>ชื่อตัวอย่าง </strong>
                  {bookingText.sampleName}
                </TextNormal>
              )}
            </div>
            {(bookingText.typeFlight ||
              bookingText.typeProduct ||
              bookingText.numberOfPassenger ||
              bookingText.weightProduct) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  gap: "2px",
                  marginTop: "10px",
                  maxWidth: "100px",
                  justifyContent: "flex-end",
                }}
              >
                {bookingText.typeFlight && (
                  <TextNormal>{bookingText.typeFlight}</TextNormal>
                )}
                {bookingText.typeProduct && (
                  <TextNormal>{bookingText.typeProduct}</TextNormal>
                )}
                {bookingText.numberOfPassenger && (
                  <TextNormal>{bookingText.numberOfPassenger}</TextNormal>
                )}
                {bookingText.weightProduct && (
                  <TextNormal>{bookingText.weightProduct}</TextNormal>
                )}
              </div>
            )}
            {bookingText.status && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  marginTop: "10px",
                  maxWidth: "100px",
                  justifyContent: "flex-end",
                }}
              >
                {bookingText.status === "ได้รับสินค้าเรียบร้อย" ||
                bookingText.status === "รายการเสร็จสิ้น" ? (
                  <CheckCircleRoundedIcon
                    style={{ color: "#4CAF50", fontSize: "18px" }}
                  />
                ) : (
                  <HourglassTopRoundedIcon
                    style={{
                      fontSize: "18px",
                      color:
                        bookingText.status === "ส่งสินค้าเรียบร้อย"
                          ? "#2196F3"
                          : bookingText.status === "รับสินค้าเรียบร้อย" ||
                            bookingText.status === "กำลังดำเนินการ"
                          ? "#FF9800"
                          : bookingText.status === "รอรับสินค้า" ||
                            bookingText.status === "รอการจัดหาคนขับรถ"
                          ? "#F44336"
                          : "inherit",
                    }}
                  />
                )}
                <StatusText
                  status={bookingText.status}
                  style={{ fontSize: "14px", fontWeight: "500" }}
                  typeOfBooking={typeOfBooking}
                >
                  {bookingText.status}
                </StatusText>
              </div>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <TextNormal style={{ fontSize: "14px" }}>
              <strong>{bookingText.startDateLabel}</strong>
              {bookingText.startTime
                ? `${bookingText.startDate} ${bookingText.startTime}`
                : bookingText.startDate}
            </TextNormal>
            {bookingText.returnDate && (
              <TextNormal style={{ fontSize: "14px" }}>
                <strong>{bookingText.returnDateLabel}</strong>
                {bookingText.returnTime
                  ? `${bookingText.returnDate} ${bookingText.returnTime}`
                  : bookingText.returnTime}
              </TextNormal>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <SiteInfo iconColor="green" siteName={bookingText.fromPlace} />
            <SiteInfo iconColor="red" siteName={bookingText.toPlace} />
          </div>
        </div>
      </div>
    </RowStyled>
  ) : (
    <RowStyled
      sx={{
        "& .MuiTableCell-root": {
          borderBottom: "none",
          borderTop: "none",
        },
      }}
      onClick={() => onClickCardHandler(typeOfBooking, bookingText.bookingId)}
    >
      <TableCell>
        <Typography
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
        >
          <AvatarStyled
            src={`${process.env.REACT_APP_URL}image/profile/1.jpg`}
            alt="1"
          />
          <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
            <TextNormal>{bookingText.name}</TextNormal>
            {bookingText.email && (
              <TextSmall>{`${"อีเมล: " + bookingText.email}`}</TextSmall>
            )}
            <TextSmall>{`${"เบอร์โทรศัพท์: " + bookingText.phone}`}</TextSmall>
          </div>
        </Typography>
      </TableCell>
      {bookingText.sampleName && (
        <TableCell>
          <TextNormal>{bookingText.sampleName}</TextNormal>
        </TableCell>
      )}
      <TableCell>
        <TextNormal>{bookingText.startDate}</TextNormal>
        {bookingText.startTime && (
          <TextSmall>{bookingText.startTime}</TextSmall>
        )}
      </TableCell>
      {bookingText.returnDate ? (
        bookingText.returnDate === "Invalid Date" ? (
          <TableCell>
            <TextNormal>-</TextNormal>
          </TableCell>
        ) : (
          <TableCell>
            <TextNormal>{bookingText.returnDate}</TextNormal>
            {bookingText.returnTime && (
              <TextSmall>{bookingText.returnTime}</TextSmall>
            )}
          </TableCell>
        )
      ) : (
        typeOfBooking === "DriverBooking" && (
          <TableCell>
            <TextNormal>-</TextNormal>
          </TableCell>
        )
      )}

      <TableCell>
        <SiteInfo iconColor="green" siteName={bookingText.fromPlace} />
        <SiteInfo iconColor="red" siteName={bookingText.toPlace} />
      </TableCell>
      {bookingText.status && (
        <TableCell>
          <TextNormal sx={{ display: "flex" }}>
            {bookingText.status === "ได้รับสินค้าเรียบร้อย" ||
            bookingText.status === "รายการเสร็จสิ้น" ? (
              <CheckCircleRoundedIcon
                style={{ color: "#4CAF50", marginRight: "5px" }}
              />
            ) : (
              <HourglassTopRoundedIcon
                style={{
                  fontSize: "18px",
                  color:
                    bookingText.status === "ส่งสินค้าเรียบร้อย"
                      ? "#2196F3"
                      : bookingText.status === "รับสินค้าเรียบร้อย" ||
                        bookingText.status === "กำลังดำเนินการ"
                      ? "#FF9800"
                      : bookingText.status === "รอรับสินค้า" ||
                        bookingText.status === "รอการจัดหาคนขับรถ"
                      ? "#F44336"
                      : "inherit",
                }}
              />
            )}
            <StatusText
              status={bookingText.status}
              typeOfBooking={typeOfBooking}
            >
              {bookingText.status}
            </StatusText>
          </TextNormal>
        </TableCell>
      )}
      {bookingText.typeFlight && (
        <TableCell>
          <TextNormal>{bookingText.typeFlight}</TextNormal>
        </TableCell>
      )}
      {bookingText.typeProduct && (
        <TableCell>
          <TextNormal>{bookingText.typeProduct}</TextNormal>
        </TableCell>
      )}
      {bookingText.numberOfPassenger && (
        <TableCell>
          <TextNormal>{bookingText.numberOfPassenger}</TextNormal>
        </TableCell>
      )}
      {bookingText.weightProduct && (
        <TableCell>
          <TextNormal>{bookingText.weightProduct}</TextNormal>
        </TableCell>
      )}
    </RowStyled>
  );
};

export default Body;
